export const ROUTE_HAS_CHANGED = 'route/ROUTE_HAS_CHANGED';

export function routeHasChanged(locationObject) {
  return {
    type: ROUTE_HAS_CHANGED,
    payload: locationObject,
  }
}



// WEBPACK FOOTER //
// ./src/state/route/actions/index.js